import update from 'immutability-helper';
import _ from 'lodash';

const chat = (state = {
	visitors:{

	},
	messages:{

	},
	subscribers:{

	},
	pages: {

	},
	cart: {

	},

	conversations: {

	},

	initialized:false,
	isOnline:false,
	filterOptions:[],
	currentTab:1,
	currentChat:false,
	waitingForVisitorResponse:false,
}, action) => {

	let newState = state;
	let i = 0;

	switch(action.type) {

		case 'CHAT_SET_VISITOR_KEY':
			newState = {
				...state,
				visitors:{
					...state.visitors,
					[action.payload.uid]: {
						...state.visitors[action.payload.uid],
						[action.payload.key]:action.payload.value
					}
				}
			}
		break;


		case 'CHAT_ADD_MESSAGE':

			let message = JSON.parse(action.payload.message);

			if(!state.conversations[action.payload.uid]) {
				state = {
					...state,
					conversations: {
						...state.conversations,
						[action.payload.uid]:[]
					}
				}
			}

			

			if(parseInt(message.from) == 0) {
				state = {
					...state,
					visitors:{
						...state.visitors,
						[action.payload.uid]: {
							...state.visitors[action.payload.uid],
							unreadMessages: parseInt(state.visitors[action.payload.uid].unreadMessages)+1
						}
					}
				}
			}else{
				state = {
					...state,
					visitors:{
						...state.visitors,
						[action.payload.uid]: {
							...state.visitors[action.payload.uid],
							unreadMessages: 0
						}
					}
				}
			}

			newState = {
				...state,
				conversations:{
					...state.conversations,
					[action.payload.uid]: [
						...state.conversations[action.payload.uid],
						action.payload.message
					]
				}
			}


		break;

		case 'CHAT_REMOVE_VISITOR':
			newState = {
				...state,
				visitors:_.omit(state.visitors, action.payload)
			}
		break;

		case 'CHAT_SET_ASSIGNEE':
			newState = {
				...state,
				visitors:{
					...state.visitors,
					[action.payload.uid]: {
						...state.visitors[action.payload.uid],
						assignee_id:action.payload.user_id
					}
				}
			}
		break;

		case 'CHAT_SET_STATUS':

			if(action.payload == 'true') {
				action.payload = true;
			}
			if(action.payload == 'false') {
				action.payload = false;
			}

			
			newState = {
				...state,
				isOnline:action.payload != 'none' ? action.payload:!state.isOnline
			}

		break;

		case 'CHAT_SET_INIT':
			newState = {
				...state,
				initialized:action.payload
			}

		break;

		case 'CHAT_SET_GLOBAL_KEY':
			newState = {
				...state,
				[action.payload.key]:action.payload.value
			}

		break;

		case 'CHAT_ADD_VISITOR_DATA':
			newState = {
				...state,
				[action.payload.key]: {
					...state[action.payload.key],
					[action.payload.uid]: action.payload.data
				}
			}
		break;
		case 'CHAT_SET_OPEN_CHAT':


			newState = {
				...state,
				currentTab:action.payload.tab,
				currentChat:action.payload.uid
			}
		break;

		case 'CHAT_SET_TAB':
			newState = {
				...state,
				currentTab:action.payload
			}
		break;

		case 'CHAT_ADD_VISITOR':
			newState = {
				...state,
				visitors:{
					...state.visitors,
					[action.payload.uid]:action.payload
				}
			}
		break;

		case 'CHAT_UPDATE_VISITOR':
			newState = {
				...state,
				visitors:{
					...state.visitors,
					[action.payload.uid]:action.payload
				}
			}

		break;

		case 'CHAT_ADD_VISITORS':
			newState = {
				...state,
				visitors:action.payload
			}
		break;

        case 'CHAT_ADD_CARTS':
            newState = {
                ...state,
                cart:action.payload
            }
			break;
			
        case 'CHAT_ADD_PAGES':
            newState = {
                ...state,
                pages:action.payload
            }
            break;

		case 'CHAT_RESET_FILTER':
			newState = {
				...state,
				filterOptions:[]
			}
		break;

		case 'CHAT_SET_FILTER_OPTION':
			let found = false;

			for(let i in state.filterOptions) {
				if(state.filterOptions[i].key == action.payload.key) {
					found = true;
				}
			}

			if(!found) {
				newState = {
					...state,
					filterOptions:[
						...state.filterOptions,
						action.payload
					]
				}
			}
		break;

		case 'CHAT_REMOVE_FILTER_OPTION':
			newState = {
				...state,
				filterOptions:state.filterOptions.filter((item,i) => {
					return i !== action.payload
				})
			}
		break;

	}

	return newState;
}



export default chat;


// WEBPACK FOOTER //
// ./reducers/chatReducer.js